import React from 'react';
import styled, { useTheme } from 'styled-components';
import Footer from '../containers/Footer';
import RejectedImg from '../assets/rejected.svg';
import Spacer from '../components/Spacer';
import Button from '../components/Button';
import OfertaReal from '../components/OfertaReal';
import OfertasImg from '../assets/money.json';
import Lottie from 'lottie-react';
import useFormStore from "../state/useFormStore";
import withAuthAndData from '../components/withAuthAndData';

const Wrapper = styled.div`
  min-height: 100vh;  
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const WaitImage = styled.img`
  width: 70%;
  height: auto;
  max-width: 300px;
`;

const MainText = styled.div`
  margin: 30px 0 0 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: #333;
  text-align: center;
`;

const Subtext = styled.h4`
  font-size: 18px;
  line-height: 26px;
  font-weight: 400;
  color: #666;
  margin: 0 0 40px 0;
  text-align: center;
  width: 80%;

  @media (orientation: portrait) and (max-width: 767px) {
    width: 100%;
  }
`;

const ExtraText = styled.h5`
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  color: #666;
  margin: 30px 0 0 0;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  justify-content: center;
  margin-bottom: 50px;

  @media (orientation: portrait) and (max-width: 767px) {
    width: 100%;
  }
`;

const Oferta: React.FC = () => {
  const theme = useTheme();
  const { first_name, preOffers } = useFormStore(state => ({ 
    first_name: state.first_name,
    preOffers: state.preOffers
  }));

  const goToBlog = () => {
    window.open('#');
  };

  return (
    <Wrapper>
      <MainText>¡Ya falta menos!</MainText>
      <OfertaReal />
    </Wrapper>
  );
};

export default withAuthAndData(Oferta);
